import graphqlClient from '@/graphql/graphql-client';
import { toPagingOnlyVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TaskManagerTagsDocument,
  type TaskManagerTagsQuery,
} from '@/graphql/generated/graphql';

export type TaskManagerTagRecord = NonNullable<
  NonNullable<TaskManagerTagsQuery['getTaskManagerTags']>['items']
>[number];
export type GetTaskManagerTagsResponse = TaskManagerTagsQuery;

export const useGetTaskManagerTags = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return useQuery({
    queryKey: ['task-manager-tags', variables],
    queryFn: () => graphqlClient.request(TaskManagerTagsDocument, variables),
  });
};

export const requestTaskManagerTags = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return graphqlClient.request(TaskManagerTagsDocument, variables);
};

export const GET_TASK_MANAGER_TAGS_QUERY = TaskManagerTagsDocument;
